import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconEditCard = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M7.2 2.281c-1.367.166-2.343.657-3.274 1.646-.763.811-1.131 1.504-1.331 2.505-.093.464-.1 2.575-.085 22.432.017 20.841.024 21.939.132 22.304.584 1.956 2.216 3.447 4.138 3.779.473.081 2.001.092 10.949.078l10.399-.017.366-.18c1.236-.607 1.517-2.231.552-3.196a2.7 2.7 0 0 0-.615-.452l-.303-.14-10.405-.032-10.404-.032-.267-.176a1.5 1.5 0 0 1-.41-.448l-.146-.272V7.2l.155-.271c.086-.15.27-.35.41-.448l.256-.177 15.323-.017c14.864-.016 15.331-.012 15.59.104.31.14 6.99 6.524 7.147 6.83.082.162.1 1.351.127 8.923l.032 8.736.149.303c.214.434.665.853 1.092 1.014.285.107.459.13.841.109.804-.045 1.36-.433 1.72-1.2l.166-.354v-8.8c0-8.354-.006-8.826-.12-9.308-.159-.68-.376-1.178-.79-1.812-.295-.45-.863-1.023-3.878-3.917-1.943-1.864-3.69-3.508-3.884-3.653-.457-.341-1.136-.667-1.768-.847l-.504-.143-15.584-.007c-8.571-.004-15.67.004-15.776.016m8.54 10.926a2.07 2.07 0 0 0-1.286 1.065c-.198.384-.238 1.079-.087 1.532.144.435.633.965 1.072 1.164l.337.152h7.968c7.7 0 7.979-.004 8.286-.123.444-.171.876-.596 1.09-1.071.155-.346.172-.45.146-.88-.048-.802-.47-1.422-1.194-1.757l-.296-.137-7.872-.012c-6.085-.01-7.938.005-8.163.066m-.234 10.608c-.388.15-.84.563-1.053.962-.2.375-.217 1.368-.03 1.719.24.447.552.76.955.958l.398.195 10.272-.016 10.272-.017.288-.15c.587-.305.98-.831 1.076-1.442.143-.91-.27-1.727-1.094-2.168l-.27-.144-10.24-.013c-10.123-.013-10.244-.012-10.574.116m38.51 8.513c-1.048.12-2.34.624-3.2 1.25-.493.358.036-.15-8.59 8.235-3.793 3.686-7.008 6.852-7.146 7.036-.517.693-.611.977-1.873 5.671-.668 2.486-1.23 4.666-1.25 4.845-.045.401.109.97.363 1.339.197.287.529.541.928.711.526.225.796.179 5.6-.955a557 557 0 0 0 4.768-1.138c.376-.107.907-.39 1.344-.714.211-.157 2.673-2.512 5.472-5.233 8.301-8.071 9.71-9.46 10.047-9.908 1.134-1.505 1.62-3.486 1.306-5.328-.53-3.116-3.006-5.467-6.126-5.815-.688-.076-.95-.076-1.643.004m.064 4.062c-.194.051-.51.191-.703.31-.222.137-3.055 2.843-7.686 7.342-4.035 3.92-7.367 7.174-7.407 7.233-.039.06-.39 1.297-.779 2.752a340 340 0 0 1-.734 2.718c-.019.053.075.05.337-.012l2.86-.668c2.359-.55 2.507-.594 2.714-.788 1.61-1.513 14.437-14.037 14.61-14.264.65-.857.744-2.144.23-3.154-.183-.358-.824-1.007-1.192-1.207-.646-.352-1.526-.454-2.25-.262" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconEditCard.displayName = 'IconEditCard';